// extracted by mini-css-extract-plugin
export default {"triangleDown":"Pricing_triangleDown__+shXJ","Header":"Pricing_Header__4DD9+"};